export default __webpack_public_path__ + "static/media/Rectangle 2761.37db7ef8.svg";